export default __webpack_public_path__ + "static/media/cycling.625bb2a6.svg";